module.exports = __webpack_public_path__ + "img/uk-hotels-4.813457fc.png";